import { useContext } from "react";
import axios from "axios";
import { Context } from "../context/Context";
import { useNavigate } from "react-router-dom";
import appConstant from "./../json/appConstant.json"
const ENDPOINT = process.env.REACT_APP_BASEURL;


const useAuthApis = () => {

  const navigate = useNavigate();

  axios.defaults.headers.common["Authorization"] = localStorage.getItem("bearerToken");
  axios.defaults.headers.common["Content-Type"] = "application/json";
  const {
    setUserData,
    setIsAuthorized,
    setIsLoading
  } = useContext(Context);
  axios.interceptors.response.use(
    response => response, // If the response is successful, just return it
    error => {
      if (error.response && error.response.status === 409) {
        setIsAuthorized(false)
        setUserData({})
        navigate("/")
      }
      return Promise.reject(error);
    }
  );


  const loginApi = async (data) => {
    try {
      const res = await axios[appConstant.login.method](`${ENDPOINT}${appConstant.login.path}`, data);
      setUserData(res.data.data);
      localStorage.setItem("bearerToken", res.data.data.accessToken);
      setIsAuthorized(true);
      navigate("/");
      return { error: false, message: res.data.data.message }
    } catch (error) {
      return { error: true, message: error.response.data.message }
    }
  }

  const homeApi = async () => {
    try {
      const res = await axios[appConstant.home.method](`${ENDPOINT}${appConstant.home.path}`,);
      if (res.response.status)
        setUserData(res.data.user);
      setIsAuthorized(true);
      return { error: false, message: res.data.data.message }
    } catch (error) {
      if (error?.response?.status === 405) {
        localStorage.removeItem("bearerToken")
        setIsAuthorized(false)
        setUserData({});
        navigate("/session-expired")
      }
    }
  }

  const logOutApi = async () => {
    try {
      // const res = await axios[appConstant.logout.method](`${ENDPOINT}${appConstant.login.path}`);
      localStorage.removeItem("bearerToken")
      setUserData({})
      setIsAuthorized(false)
      navigate("/")
    }
    catch (error) {
      navigate("/")
    }
  }

  const forgetPasswordApi = async (data) => {
    try {
      const res = await axios[appConstant.forgotPassword.method](
        `${ENDPOINT}${appConstant.forgotPassword.path}`,
        data
      );
      console.log("Response:", res);
      if (res && res.data) {
        return {
          error: false,
          message: res.data.message || "Success",
          data: res.data
        };
      } else {
        return { error: true, message: "Unexpected response structure" };
      }
    } catch (error) {
      return {
        error: true,
        message: error.response?.data?.message || "An error occurred"
      };
    }
  };

  const resetPasswordApi = async ({ password, confirmPassword, token }) => {
    try {
      const res = await axios[appConstant.resetPassword.method](
        `${ENDPOINT}${appConstant.resetPassword.path}`,
        { password, confirmPassword, token }
      );
      console.log('Reset Password Response:', res); // Log the response
      if (res.data && res.data.message) {
        return { error: false, message: 'Password changed successfully' };
      } else {
        return { error: true, message: 'Something went wrong' };
      }
    } catch (error) {
      console.error('Error resetting password:', error.response || error.message); // Log error details
      return {
        error: true,
        message: error.response?.data?.message || 'An error occurred',
      };
    }
  };


  return {
    loginApi,
    logOutApi,
    homeApi,
    forgetPasswordApi,
    resetPasswordApi
  };

};

export default useAuthApis;